const en = {
  // Navbar
  home: 'Home', clients: 'Clients/Customers', news: 'News', about: 'About',
  contact: 'Contact', signIn: 'Sign In', register: 'Register',
  signOut: 'Sign Out', myDashboard: 'My Dashboard', team: 'Team',

  // Ad splash
  adOf: (i, n) => `Ad ${i} of ${n}`,
  watchAd: 'Please watch the ad to continue',
  secondsLeft: (s) => `${s} second${parseFloat(s) !== 1 ? 's' : ''} remaining`,
  overall: 'Overall',
  complete: 'complete',

  // Home
  heroTag: 'Licensed MSMEs Only',
  heroTitle1: 'E-Commerce & Digital Marketing for',
  heroTitle2: 'Licensed MSMEs',
  heroDesc: 'We exclusively partner with verified, licensed MSMEs to create authentic social media presence and e-commerce solutions.',
  // Links page
  linksTagline: 'E-Commerce & Digital Marketing for Licensed MSMEs · Addis Ababa, Ethiopia',
  linksDesc: 'We help verified, licensed MSMEs grow through e-commerce solutions, digital marketing, and authentic social media presence.',
  linksWebsite: 'Website',
  applyNow: 'Apply Now',
  viewClients: 'View Clients/Customers',
  seeMore: 'See More →',
  totalClients: 'Clients/Customers', licensed: 'Licensed', avgGrowth: 'Avg Growth',
  ourServices: 'Our Services',

  // Clients categories
  catAll: 'All', catStartups: 'Startups & Entrepreneurs',
  catRetail: 'Retail & Wholesale', catHospitality: 'Hospitality & Tourism',
  catEducation: 'Educational Institutions', catServices: 'Service Providers',
  catManufacturers: 'Manufacturers',
  allCities: '📍 All Cities', clearFilter: '✕ Clear',
  noClientsInCity: (city) => `No clients/customers found in ${city}.`,
  noClientsInCategory: 'No clients/customers in this category yet.',
  verifiedBusinesses: 'Verified licensed businesses we promote',
  verified: '✓ Verified',
  followers: 'Followers', growth: 'Growth', engagement: 'Engagement',
  noClients: 'No clients/customers yet.',

  // News
  newsTitle: 'News', latestUpdates: 'Latest updates and articles',
  readMore: 'Read More →', readLess: 'Show Less ↑', noNews: 'No articles yet.',
  loading: 'Loading...',
  sourceRef: '📎 Source / Reference →',
  categories: { General: 'General', Marketing: 'Marketing', Business: 'Business', Technology: 'Technology', News: 'News', Events: 'Events', Tips: 'Tips' },

  // About
  aboutTitle: 'About Us', aboutSub: 'We are',
  vision: 'Vision', mission: 'Mission',
  visionText: "To become Ethiopia's leading digital marketing and e-commerce solutions company dedicated to empowering MSMEs — All Things by All Things Solution.",
  missionText: 'To deliver innovative, affordable and measurable marketing and advertising solutions that help Ethiopian MSMEs grow sustainably.',
  coreValues: 'Core Values',
  strategicObjectives: 'Strategic Objectives',
  so1: 'Provide nationwide access to professional marketing services',
  so2: 'Support MSMEs growth through digital visibility and branding',
  so3: 'Utilize technology (website, mobile app, and social media) for service delivery',
  so4: 'Build long-term partnerships with MSMEs and institutions',
  so5: 'Create employment opportunities for skilled youth',

  // Contact
  contactTitle: 'Contact Us', contactSub: 'Ready to grow your business?',
  fullName: 'Full Name *', email: 'Email', phone: 'Phone *',
  company: 'Company Name', businessType: 'Business Type',
  tin: 'TIN Number', elmis: 'E-LMIS Registration',
  license: 'Business License', message: 'Message',
  submit: 'Submit Application →', submitting: 'Submitting...',
  successTitle: 'Message Sent!', successMsg: 'Thank you! We will contact you soon.',
  sendAnother: 'Send Another',
  licenseNote: '📋 Important: We only work with licensed businesses.',
  selectType: 'Select type...',
  companyToggle: 'Send as a Company',

  // Register
  registerTitle: 'Create your business account',
  accountDetails: 'Account Details', businessInfo: 'Business Info', documents: 'Documents',
  namePlaceholder: 'Full Name *', passwordPlaceholder: 'Password *',
  confirmPassword: 'Confirm Password *', minPassword: 'Min. 6 characters',
  nextBusiness: 'Next: Business Info →', nextDocs: 'Next: Documents →',
  back: '← Back', createAccount: 'Create Account →', creating: 'Creating Account...',
  alreadyHave: 'Already have an account?',
  businessLicenseReq: 'Business license number is required.',
  licenseInfo: '📋 Your information will be reviewed by our team. You\'ll receive a welcome email after registration.',
  companyNameLabel: 'Company / Business Name *',
  businessTypeLabel2: 'Business Type',
  locationLabel: 'Location (City)',
  websiteLabel: 'Website (optional)',
  businessLicenseLabel: 'Business License Number *',
  tinLabel: 'TIN Number',
  elmisLabel: 'E-LMIS Registration',
  phoneLabel2: 'Phone Number *',
  emailLabel: 'Email Address (optional)',
  fullNameLabel: 'Full Name *',
  businessDocsTitle: 'Business Documents',
  businessDocsDesc: 'We only work with licensed businesses. Please provide your official document numbers.',
  fillRequired: 'Please fill all required fields.',
  passwordMismatch: 'Passwords do not match.',
  passwordShort: 'Password must be at least 6 characters.',
  companyRequired: 'Company name is required.',
  registrationFailed: 'Registration failed.',

  // Login
  loginTitle: 'Sign in to your account',
  phoneLabel: 'Phone Number',
  passwordLabel: 'Password',
  emailPlaceholder: 'your@email.com',
  loginBtn: 'Sign In →', loggingIn: 'Signing in...',
  noAccount: "Don't have an account?", registerBusiness: 'Register your business',
  loginFailed: 'Login failed.',

  // Navbar extras
  blogsNews: 'Blogs/News',
  faq: 'FAQ',
  cart: 'Cart',
  expandSidebar: 'Expand sidebar',
  collapseSidebar: 'Collapse sidebar',

  // FAQ
  faqTitle: 'Frequently Asked Questions',
  faqSubtitle: 'Everything you need to know about All Things, the Bazaar, and our services.',
  faq1q: 'What is All Things?',
  faq1a: 'All Things is a digital marketing agency and e-commerce platform based in Addis Ababa, Ethiopia. We help licensed Ethiopian businesses grow online through marketing services and our Bazaar marketplace.',
  faq2q: 'How do I register as a seller?',
  faq2a: 'Go to our Contact page and fill in the registration form with your business details, including your TIN number, business license, and Elmis registration. Our team will review your application and activate your account.',
  faq3q: 'How do I buy from the Bazaar?',
  faq3a: 'Browse products in the Bazaar, add items to your cart, and proceed to checkout. You\'ll need to register as a buyer first. Payment is handled directly between you and the seller.',
  faq4q: 'What payment methods are accepted?',
  faq4a: 'Payment methods vary by seller. Many accept bank transfer, mobile money, or cash on delivery within Addis Ababa. Check the product page for seller-specific payment options.',
  faq5q: 'How does delivery work?',
  faq5a: 'Delivery arrangements are made directly with the seller after purchase. Many sellers offer delivery within Addis Ababa. You can discuss delivery options with your seller via our chat feature.',
  faq6q: 'Is there a return policy?',
  faq6a: 'Returns are handled between you and the seller. We recommend messaging the seller through our platform before purchasing to confirm their return policy.',
  faq7q: 'How do I become a digital marketing client/customer?',
  faq7a: 'Contact us through our Contact page or email allthingsethiopia2026@gmail.com. We\'ll discuss your business needs and create a custom marketing plan.',
  faq8q: 'What services does All Things offer?',
  faq8a: 'We offer digital marketing, social media management, website development, branding, content creation, and e-commerce solutions for Ethiopian businesses.',

  // About extras
  aboutTag: 'About Us',
  aboutHeroTitle1: 'Empowering Ethiopia\'s',
  aboutHeroTitle2: 'Digital Future',
  aboutCatalyst: 'We are the catalyst for Ethiopian MSMEs growth in the modern digital marketplace.',
  whoWeAre: 'Who We Are',
  whoWeAreText: 'We are a digital marketing and e-commerce support platform helping Ethiopian MSMEs transition from traditional business methods to modern, technology-driven growth. Our mission is to bridge the gap between local quality and global visibility.',
  ourCoreValues: 'Our Core',
  ourCoreValuesHighlight: 'Values',
  strategic: 'Strategic',
  strategicHighlight: 'Objectives',

  // Register extras
  joinAllThings: 'Join All',
  joinAllThingsHighlight: 'Things',
  chooseAccountType: 'Choose your account type to get started',
  registerYourBusiness: 'Register your licensed business for professional promotion services.',
  haveAccount: 'Already have an account?',
  signIn: 'Sign In',
  registrationSubmitted: 'Registration Submitted!',
  thankYouName: (name) => `Thank you, ${name}!`,
  thankYouRegistering: 'Your account is currently under review. Our team will verify your business within 48 hours.',
  goToLogin: 'Go to Login',
  phoneMustBe9: 'Phone must be 9 digits',
  selectCity: 'Select city...',

  // Login extras
  forgot: 'Forgot?',

  // Contact info card labels
  labelEmail: 'Email',
  labelLocation: 'Location',
  labelPhone: 'Phone',
  labelHours: 'Hours',
  labelTelegram: 'Telegram',
  labelWhatsApp: 'WhatsApp',
  contactLocationCity: 'Location (City)',
  alertFullNameRequired: 'Full name is required',
  alertPhoneDigits: 'Phone must be 9 digits (e.g. 911031884)',
  alertValidEmail: 'Please enter a valid email address',
  alertSubmissionFailed: 'Submission failed. Please try again.',
  alertCompanyRequired: 'Company name is required.',
  alertTinRequired: 'TIN number is required.',
  alertElmisRequired: 'E-LMIS registration is required.',
  alertBusinessTypeRequired: 'Business type is required.',

  // Chat
  messages: '💬 Messages',
  noConversations: 'No conversations yet.',
  selectConversation: 'Select a conversation to start chatting',
  typeMessage: 'Type a message...',
  new: 'new',

  // Dashboard
  myDashboardTitle: 'My Dashboard',
  underReview: 'Account Under Review',
  underReviewMsg: "Our team is reviewing your business information. We'll contact you within 1–2 business days.",
  profileTab: '👤 Profile', businessTab: '🏢 Business Info',
  socialTab: '📱 Social & Extra', passwordTab: '🔒 Password',
  saveChanges: 'Save Changes', saving: 'Saving...',
  profileUpdated: 'Profile updated successfully.',
  passwordChanged: 'Password changed successfully.',
  currentPassword: 'Current Password', newPassword: 'New Password',
  confirmNewPassword: 'Confirm New Password',
  changePassword: 'Change Password',

  // Footer
  footerTagline: 'E-Commerce & Digital Marketing · Addis Ababa, Ethiopia',
  copyright: '© 2026 All Things Solution PLC',

  // Client detail
  backToClients: '← Back to Clients/Customers',
  established: 'Established', location: 'Location',
  verifiedLicensed: 'Verified Licensed Business',
  licenseLabel: 'License',
  ourMarketingWork: 'Our Marketing Work',
  videoContent: 'Video Content',
  video: 'Video',
  watch: 'Watch ↗',
  businessTypeLabel: 'Business Type',
  contactSocial: 'Contact & Social Media',
  sourceRef: '📎 Source / Reference →',

  // Services
  service1Title: 'Social Media Management',
  service1Desc: 'Complete management of your social accounts',
  service2Title: 'Content Creation',
  service2Desc: 'Professional photos, videos & graphics',
  service3Title: 'Growth Strategy',
  service3Desc: 'Data-driven strategies for growth',
  service4Title: 'Paid Advertising',
  service4Desc: 'Targeted ads on all platforms',

  // Core values
  cv1Title: 'Innovation and Creativity', cv1Desc: 'We embrace new ideas and creative solutions',
  cv2Title: 'Customer-Centered Service',   cv2Desc: "Our customers' success is at the heart of everything we do",
  cv3Title: 'Integrity and Transparency', cv3Desc: 'We operate with honesty and openness',
  cv4Title: 'Technology Adoption', cv4Desc: 'We leverage the latest digital tools',
  cv5Title: 'Results-Oriented Performance', cv5Desc: 'We focus on measurable outcomes',

  // Team
  teamOurPeople: 'Our People',
  teamTitle: 'Meet the',
  teamTitleHighlight: 'Team',
  teamSubtitle: 'The talented people behind All Things Solution',
  teamMember: 'member', teamMembers: 'members',
  depts: {
    'Executive Management': 'Executive Management',
    'Creative & Digital Marketing': 'Creative & Digital Marketing',
    'Technology & Platform Support': 'Technology & Platform Support',
    'Finance & Administration': 'Finance & Administration',
    'Customer & Sales': 'Customer & Sales',
  },

  // Bazaar
  bazaarTitle: 'Bazaar',
  bazaarSubtitle: 'Browse products from all sellers in one place',
  sellerStoreTitle: 'Seller Store',
  productDetailTitle: 'Product Details',
  cartTitle: 'Your Cart',
  checkoutTitle: 'Checkout',
  deliveryTitle: 'Request Delivery',
  addToCart: 'Add to Cart',
  proceedToCheckout: 'Proceed to Checkout',
  placeOrder: 'Place Order',
  confirmPayment: 'Confirm Payment',
  rejectPayment: 'Reject Payment',
  requestDelivery: 'Request Delivery',
  addProduct: 'Add Product',
  editProduct: 'Edit Product',
  deleteProduct: 'Delete Product',
  outOfStock: 'Out of Stock',
  inStock: 'In Stock',
  pendingPayment: 'Pending Payment',
  confirmedOrder: 'Confirmed',
  rejectedOrder: 'Rejected',
  removedByAdmin: 'Removed by Admin',
  filterByCategory: 'Filter by Category',
  filterBySeller: 'Filter by Seller',
  priceRange: 'Price Range',
  searchProducts: 'Search products...',
  noResults: 'No products found.',
  selectBank: 'Select Payment Method',
  bankAccountNumber: 'Account Number',
  transferInstructions: 'Please transfer the total amount to the account number above using your banking app, then submit your payment proof below.',
  uploadScreenshot: 'Upload Screenshot',
  enterReference: 'Enter Reference Number',
  orderConfirmation: 'Order placed successfully! Your order ID is',
  emptyCart: 'Your cart is empty.',
  cartTotal: 'Total',
  unitPrice: 'Unit Price',
  quantity: 'Quantity',
  lineTotal: 'Subtotal',
  linkedOrder: 'Select Order',
  deliveryAddress: 'Delivery Address',
  contactPhone: 'Contact Phone',
  preferredTime: 'Preferred Delivery Time',
  deliveryConfirmation: 'Delivery request submitted! Your request ID is',
  myStoreTab: '🛍️ My Store',
  myOrdersTab: '📦 My Orders',
  myPurchasesTab: '🛒 My Purchases',
  productName: 'Product Name',
  productDescription: 'Description',
  productPrice: 'Price (ETB)',
  productCategory: 'Category',
  productStock: 'Stock Quantity',
  productPhotos: 'Photos (up to 5)',
  productNotFound: 'Product not found.',
  sellerNotFound: 'Seller not found.',
  outOfStockError: 'Some items in your cart are out of stock.',
  deliveryDuplicateError: 'A delivery request already exists for this order.',
  loginRequired: 'Please sign in to continue.',
  backToBazaar: '← Back to Bazaar',
  allCategories: 'All Categories',
  allSellers: 'All Sellers',
  minPrice: 'Min Price',
  maxPrice: 'Max Price',
  viewCart: 'View Cart',
  bankManagement: 'Bank Accounts',
  addBankAccount: 'Add Bank Account',
  noOrders: 'No orders yet.',
  noDeliveryRequests: 'No delivery requests yet.',
  waitingConfirmation: 'Waiting for seller confirmation.',

  // Buyer account
  registerAsSeller: 'Register as Seller',
  registerAsBuyer: 'Register as Buyer',
  buyerRegisterTitle: 'Create your buyer account',
  myOrders: 'My Orders',
  buyerDashboardTitle: 'My Purchase History',
  purchaseHistory: 'Purchase History',
  groupedByCategory: 'By Category',
  groupedBySeller: 'By Seller',
  noPurchases: 'No purchases yet.',
  instantlyActive: 'Your account is active!',
  buyerRegisterSuccess: 'Registration successful!',

  // Home extras
  connectWithUs: 'Connect With Us',
  ourRoots: 'Our Roots',
  bridgingTitle: 'Bridging Tradition &',
  bridgingHighlight: 'Innovation',
  rootsText: 'We empower Ethiopian MSMEs to thrive in the global digital landscape while staying true to our rich heritage. From local markets to digital storefronts, we are your partner in growth.',
  ourStory: 'Our Story',
  ourServicesTag: 'Our Services',
  whatWeDeliver: 'What We',
  whatWeDeliverHighlight: 'Deliver',
  viewMore: 'View More →',
  servicesBoost: 'Services We Provide To Boost Your Business',
  readyToScale: 'Ready to Scale Your Business?',
  joinEntrepreneurs: 'Join hundreds of Ethiopian entrepreneurs growing their digital presence today.',
  appStore: 'App Store',
  googlePlay: 'Google Play',

  // Service cards
  svcSocialMedia: 'Social Media Management',
  svcSocialMediaDesc: 'Complete management of your social media accounts with consistent posting, audience engagement, and content strategy.',
  svcContentCreation: 'Content Creation',
  svcContentDesc: 'Professional photos, videos, and graphics that tell your brand story and captivate your target audience.',
  svcGrowthStrategy: 'Growth Strategy',
  svcGrowthDesc: 'Data-driven strategies designed to accelerate your business growth and expand market reach.',
  svcPaidAds: 'Paid Advertising',
  svcAdsDesc: 'Targeted advertising campaigns across all platforms to maximize ROI and reach the right customers.',
  svcBranding: 'Branding & Logo Design',
  svcBrandingDesc: 'Memorable brand identity, logo creation, and visual storytelling that sets you apart from competitors.',
  svcOutdoor: 'Outdoor Advertising',
  svcOutdoorDesc: 'Billboards, banners, and offline visibility solutions to complement your digital marketing efforts.',
  svcEcommerce: 'E-Commerce Setup',
  svcEcomDesc: 'Complete online store setup, product listing, and marketplace integration on the All Things Bazaar.',
  svcConsultation: 'Business Consultation',
  svcConsultDesc: 'Expert guidance and strategic advice to help your business navigate the digital landscape effectively.',

  // Clients extras
  ourPartners: 'Our',
  ourPartnersHighlight: 'Partners',
  partnersDesc: 'Meet the innovative Ethiopian businesses scaling their digital presence with All Things.',
  category: 'Category',
  allCategoriesLabel: 'All Categories',
  city: 'City',

  // News extras
  updatesTag: 'Updates',
  latestNews: 'Latest',
  latestNewsHighlight: 'News',
  newsDesc: "Stay informed with the latest developments in Ethiopia's digital economy.",
  sources: 'Sources',

  // Team extras
  viewProfile: 'View Profile',

  // Dashboard extras
  personalInformation: 'Personal Information',
  businessInformation: 'Business Information',
  yearEstablished: 'Year Established',
  numberOfEmployees: 'Number of Employees',
  socialMediaExtra: 'Social Media & Extra Details',
  instagramHandle: '📸 Instagram Handle',
  tiktokHandle: '🎵 TikTok Handle',
  telegramLabel: '✈️ Telegram',
  facebookPage: '📘 Facebook Page',
  servicesNeeded: 'Services Needed',
  servicesNeededPlaceholder: 'e.g. Social media management, content creation...',
  aboutYourBusiness: 'About Your Business',
  aboutYourBusinessPlaceholder: 'Tell us about your business...',

  // Order labels
  orderNumber: 'Order #',
  bank: 'Bank',
  proof: 'Proof',
  screenshot: 'Screenshot',
  ref: 'Ref',

  // Marketplace — hardcoded text localized
  mpTopAllCategories: 'All Categories',
  mpTopSearchPlaceholder: 'Search products, businesses, categories...',
  mpTopDashboard: 'Dashboard',
  mpTopRegister: 'Register',
  mpSearchCategory: 'Category',
  mpSearchAllCategories: 'All Categories',
  mpSearchLocation: 'Location',
  mpSearchAllCities: 'All Cities',
  mpSearchKeyword: 'What are you looking for?',
  mpSearchBtn: 'Search',
  mpTapToRead: 'Tap to read ▼',
  mpVisitStore: 'Visit Store →',
  mpSales: 'sales',
  mpProducts: 'products',
  mpPaymentCreditCard: 'Credit Card',
  mpPaymentBankTransfer: 'Bank Transfer',
  mpPaymentMobileMoney: 'Mobile Money',
  mpPaymentCashDelivery: 'Cash on Delivery',
  mpPaymentTelebirr: 'Telebirr',
  mpFooterHome: 'Home',
  mpFooterBazaar: 'Bazaar',
  mpFooterAbout: 'About Us',
  mpFooterContact: 'Contact',
  mpFooterNews: 'News',
  mpFooterTeam: 'Team',
  mpFooterRegister: 'Register',
  mpFooterDashboard: 'Dashboard',
  mpFooterSellerGuide: 'Seller Guide',
  mpFooterPricing: 'Pricing',
  mpFooterFAQ: 'FAQ',
  mpFooterContactUs: 'Contact Us',
  mpFooterPrivacy: 'Privacy Policy',
  mpFooterTerms: 'Terms of Service',
  mpFooterEthiopia: '🇪🇹 Ethiopia',
  mpFooterEnglish: 'English',

  // Marketplace Homepage
  mpHeroTag: "Ethiopia's #1 Marketplace for Verified Businesses",
  mpHeroTitle: "Ethiopia's #1 Marketplace for",
  mpHeroTitleHighlight: 'Verified Businesses',
  mpHeroDesc: 'Discover trusted Ethiopian businesses, shop quality products, and grow your brand on Africa\'s rising digital marketplace.',
  mpStartShopping: 'Start Shopping →',
  mpRegisterBusiness: 'Register Your Business',
  mpStatBusinesses: 'Verified Businesses',
  mpStatProducts: 'Products Listed',
  mpStatCities: 'Cities Covered',
  mpStatSatisfaction: 'Customer Satisfaction',
  mpSearchCategory: 'Category',
  mpSearchLocation: 'Location',
  mpSearchKeyword: 'What are you looking for?',
  mpSearchBtn: 'Search',
  mpTrustVerified: 'Verified Businesses',
  mpTrustSecure: 'Secure Payments',
  mpTrustReturns: 'Easy Returns',
  mpTrust247: '24/7 Support',
  mpTrustVerifiedDesc: 'All businesses are licensed and verified',
  mpTrustSecureDesc: 'Protected transactions every step',
  mpTrustReturnsDesc: 'Hassle-free return policy',
  mpTrust247Desc: 'We are here to help anytime',
  mpCatTag: 'Categories',
  mpCatTitle: 'Shop by',
  mpCatTitleHighlight: 'Category',
  mpCatDesc: 'Browse thousands of products across popular categories',
  mpFeaturedTag: 'Featured',
  mpFeaturedTitle: 'Featured',
  mpFeaturedTitleHighlight: 'Verified Businesses',
  mpFeaturedDesc: 'Top-rated businesses handpicked for quality and trust',
  mpToolsTag: 'MSME Tools',
  mpToolsTitle: 'Everything You Need to',
  mpToolsTitleHighlight: 'Succeed',
  mpToolsDesc: 'Powerful tools designed specifically for Ethiopian MSMEs',
  mpPartnersTag: 'Partners',
  mpPartnersTitle: 'Our Financial',
  mpPartnersTitleHighlight: 'Partners',
  mpPartnersDesc: 'Trusted by leading Ethiopian financial institutions',
  mpPaymentsTag: 'Payments',
  mpPaymentsTitle: 'Secure Payment',
  mpPaymentsTitleHighlight: 'Methods',
  mpPaymentsDesc: 'Multiple secure payment options for your convenience',
  mpTestimonialTag: 'Testimonials',
  mpTestimonialTitle: 'What Our',
  mpTestimonialTitleHighlight: 'Sellers Say',
  mpTestimonialDesc: 'Hear from businesses thriving on All Things',
  mpNewsletterTitle: 'Stay Updated',
  mpNewsletterDesc: 'Subscribe to get the latest deals, new products, and marketplace news delivered to your inbox.',
  mpNewsletterPlaceholder: 'Enter your email',
  mpNewsletterBtn: 'Subscribe',
  mpNewsletterSuccess: '✓ Thank you for subscribing!',
  mpFooterDesc: "Ethiopia's premier digital marketplace connecting verified businesses with customers across the nation.",
  mpFooterQuickLinks: 'Quick Links',
  mpFooterForSellers: 'For Sellers',
  mpFooterSupport: 'Support',
  mpFooterCopyright: '© 2026 All Things Solution PLC. All rights reserved.',
};

export default en;
